<template>
    <div>

        <menu-bar/>

        <div class="container-fluid" role="main" >
            <div class="row" style="margin-top: 50px">
                <div class="panel panel-info">
                    <!-- Default panel contents -->
                    <div class="panel-heading">
                        <i class="fa fa-map" aria-hidden="true"></i> LOCALIZAÇÃO NO MAPA DOS CLIENTES E POPS
                    </div>
                    <div class="panel-body mapsg ">
                        <all-maps/>
                        <br/>
                        <div class="row">
                            <div class="col-md-1">
                                <a :href="'/api/contratos/kml'" class="btn btn-danger btn-sm" style="margin-top: 15px">
                                    Baixar KML
                                </a>
                            </div>
                            <div class="col-md-4" style="padding-top: 10px">
                                <img src="image/point_azul.png"/>: <b>FIBRA</b> <br/> <img src="image/point_verde.png"/>: <b>RÁDIO</b>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<style scoped>
.mapsg {
    height: -moz-calc(100vh - (190px));
    height: -webkit-calc(100vh - (190px));
    height: calc(100vh - (190px));
    display: block;
}
</style>
<script>
import { AllMaps } from "../../components/exports";
export default {
    components: {
        AllMaps
    }
};
</script>
